import { FormControl, FormErrorMessage, FormLabel } from "@chakra-ui/react";
import { FieldErrors, FieldValues, UseFormRegister } from "react-hook-form";

import { $length, $ok } from "foundation-ts/commons";

import { G1Input } from "@components/G1Input";
import { RegisterFormValues } from "./SignupTypes";

interface BillingStepProps {
    tvaIntra?: string;
    errors: FieldErrors<RegisterFormValues>;
    register: UseFormRegister<FieldValues>;
    validate: (id: string) => boolean;
}

export default function BillingStep(props: BillingStepProps) {
    const { tvaIntra, errors, register, validate } = props;

    return (
        <FormControl isRequired isInvalid={$ok(errors.tvaIntra)}>
            <FormLabel fontSize="1.25em">Numéro de TVA intracommunautaire</FormLabel>
            <G1Input id="tvaIntra" name="tvaIntra" component="connection.form" autoFocus textTransform="uppercase"
                     registerInput={{ ...register("tvaIntra", { required: true, validate: (value: string) => validate(value) }) }} />
            <FormErrorMessage color="red.200">Le numéro de TVA est {$length(tvaIntra) === 0 ? 'requis' : 'invalide'}</FormErrorMessage>
        </FormControl>
    );
};